import { useState, type FormEvent } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../state/AuthContext";

export function LoginPage() {
  const { login, isAuthenticated, sessionChecked, loading, notice } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  if (!sessionChecked) {
    return (
      <div className="login-shell" aria-busy="true" aria-label="Restoring session">
        <div className="login-card" style={{ textAlign: "center" }}>
          <p className="page-subtitle" style={{ margin: 0 }}>
            Restoring your session…
          </p>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/app" replace />;
  }

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    try {
      await login(email.trim(), password);
      navigate("/app", { replace: true });
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : "Could not sign in");
    }
  };

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={handleSubmit} noValidate>
        <div className="login-brand">
          <h1 className="visually-hidden">Flower World</h1>
          <img className="login-brand-logo login-brand-logo-light" src="/fw-stacked-rose.svg" alt="" aria-hidden="true" />
          <img className="login-brand-logo login-brand-logo-dark" src="/fw-stacked-ondark.svg" alt="" aria-hidden="true" />
        </div>

        {notice ? <div className="alert success">{notice}</div> : null}
        {error ? <div className="alert error">{error}</div> : null}

        <div className="field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            required
            maxLength={254}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="field">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            required
            minLength={8}
            maxLength={256}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <div className="button-row">
          {/* G-136: self-service recovery, to a confirmed address only. */}
          <Link className="button plain" to="/forgot-password">
            Forgot password?
          </Link>
          <button className="button" type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </div>
      </form>
    </div>
  );
}
